import React, { useState } from 'react';
import { i18nIntl, isEmpty, isNotEmpty } from '../../lib/ep';
import { injectIntl } from 'react-intl';

import ColorPicker from '../builder/ColorPicker';
import DynamicFields from "../builder/DynamicFields";
import { AutoPostImageUploader } from '../builder/ImageUploader';
import Model from '../builder/Model';
import RichEditor from '../builder/RichEditor';

import transferPlaceholder from '../../hoc/transferPlaceholder';
const RichPlaceholder = injectIntl(transferPlaceholder(RichEditor));

export const getFinalMessages = () => {
	return [{
		id:'success',
		type:'final_message',
		text:"",
		color:'rgba(120, 195, 0, 1)',
	}, {
		id:'out_of_time',
		type:'final_message',
		text:"",
		color:'rgba(215, 35, 60, 1)',
	}, {
		id:'fail',
		type:'final_message',
		text:"",
		color:'rgba(215, 35, 60, 1)',
	}, {
		id:'out_of_moves',
		type:'final_message',
		text:"",
		color:'rgba(215, 35, 60, 1)',
	}, {
		id:'partial_success',
		type:'final_message',
		text:"",
		color:'rgba(120, 195, 0, 1)',
	}];
};

export const getInferredFinalMessages = (stage) => {
	return inferDefaults(getFinalMessages(), stage);
};

export const useFinalPage = (stage) => {
	const [ final_case, setFinalCase ] = useState('success');
	const final_messages = getInferredFinalMessages(stage);

	const actual_state = (final_case !== false) ? final_messages.find((i) => (i.id == final_case)) : null;

	return [ actual_state, setFinalCase ];
};

export const clientFinalPage = (stage, actual_state) => {
	if(actual_state == undefined) return stage;

	const final_stage = { ...stage };

	switch(actual_state.id) {
		case 'success':
			final_stage.Stage.display_status = 'success';
			break;

		case 'out_of_time':
			final_stage.Stage.display_status = 'fail_time';
			break;

		case 'out_of_moves':
			final_stage.Stage.display_status = 'fail_attempts';
			break;

		case 'fail':
			final_stage.Stage.display_status = 'fail';
			break;
	
		default:
			final_stage.Stage.display_status = 'partial_success';
			break;
	}

	return final_stage;
};

const DefaultFinalMissage = ({ model, change, stage, ...props }) => {
	const fields = props?.fields ?? [];

	const override_promo_styles = stage?.override_promo_styles ?? false;

	let default_color = '#CCCCCC';
	switch(model.id) {
		case 'success':
		case 'partial_success':
			default_color = 'rgba(120, 195, 0, 1)';
			break;

		case 'fail':
		case 'out_of_time':
		case 'out_of_moves':
			default_color = 'rgba(215, 35, 60, 1)';
			break;
	}

	return (
		<Model
			model={model}
			change={change}
			//errors={props.errors != undefined && props.errors[model.id]}
		>
			<RichPlaceholder
				name="text"
				//placeholder={(isNotEmpty(model, 'text')) ? model.text : "Edit"}
				has_emojis={true}
			>Message</RichPlaceholder>

			{(fields.includes('image')) && (
				<AutoPostImageUploader
					auto_url={`/promotions/auto_img/${stage.promotion_id}`}
					auto_type='stages'
					image={model.full_image}
					changeMulti={props.changeMulti}
					name="image"
					small_input={true}
					_size={{ fit:'auto' }}
				>Image</AutoPostImageUploader>
			)}

			{(fields.includes('color') && !override_promo_styles) && (
				<ColorPicker
					_class={{ size:60 }}
					_hide_code={true}
					name="color"
					color={model?.color ?? default_color}
					enable_reset={(model.color != undefined) ? true : false}
				>Background color</ColorPicker>
			)}
		</Model>
	)
};

const inferDefaults = (default_messages, stage) => {
	const getDBType = (id) => {
		switch(id) {
			case 'success':
				return 'ok';

			case 'out_of_time':
				return 'ko_time';

			case 'out_of_moves':
				return 'ko_attempts';

			case 'partial_success':
				return 'semi_ok';
		}

		return 'fail';
	};

	default_messages.map((message) => {
		const type = getDBType(message.id);

		if(isNotEmpty(stage, `game_feedback_${type}`)) {
			message.text = stage[`game_feedback_${type}`];
		}

		if(isNotEmpty(stage, `game_color_${type}`)) {
			message.color = stage[`game_color_${type}`];
		}

		if(isNotEmpty(stage, `game_soundfx_${type}`)) {
			message.sound = stage[`game_soundfx_${type}`];
		}

		if(isNotEmpty(stage, `game_final_image_${type}`)) {
			message.image = stage[`game_final_image_${type}`];
			message.full_image = stage[`full_game_final_image_${type}`];
		}

		return message;
	});
	// let return_data = default_messages
	// if (stage?.final_messages != undefined) {
	// 	return_data = stage.final_messages;
	// 	default_messages.map(default_message=>{
	// 		if (return_data.find(message => (message.id == default_message.id)))return;
	// 		return_data.push(default_message);
	// 	});
	// } 
	return default_messages;
};

const StageFinalMessages = ({ final_messages, change, stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const dynamic_fields = [{
		type:'final_message',
		text:"Word",
		translate:[
			{ key:'text', type:'input' },
		],
		title:(f) => {
			switch (f.id) {
				case 'partial_success':
					return i18n("Partial success");

				case 'success':
					return i18n("Game completed");

				case 'fail':
					return `${i18n("Game not completed")}: ${i18n("unsuccessful")}`;

				case 'out_of_time':
					return `${i18n("Game not completed")}: ${i18n("out of time")}`;

				case 'out_of_moves':
					return `${i18n("Game not completed")}: ${i18n("out of moves")}`;
			}
		},
	}];

	const messages = final_messages ?? inferDefaults(getFinalMessages(), stage);
	
	const visible_messages = messages.filter((message) => {
		return (!(props?.exclude ?? []).includes(message.id)) ? true : false;
	});

	const onOpen = (id) => {
		if(props.onOpen != undefined) props.onOpen(id);
	};

	const changeWithSkipped = (values) => {
		const withskipped = messages.map(m=>{
			const existing = values.find(message=>(m.id==message.id));
			if (existing) return existing;
			return m; 
		})
		change(withskipped);
	}

	const avail_locales = [];
	if(window.langs != undefined) {
		window.langs.map((loc) => {
			avail_locales.push(loc.I18nPromotion.lang);
		})
	}

	return (
		<DynamicFields
			section_title="Final messages"
			onChange={changeWithSkipped}
			field_types={dynamic_fields}
			sortable={false}
			can_copy={false}
			can_delete={false}
			can_create={false}
			has_translation={true}
			locales={avail_locales}
			fields={visible_messages}
			onClickOpen={onOpen}
		>
			<DefaultFinalMissage
				stage={stage}
				fields={props?.fields ?? []}
			/>
		</DynamicFields>
	)
};

export default injectIntl(StageFinalMessages);